var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_2084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.0149 0C31.7096 0.0031133 33.3764 0.146325 34.9966 0.417183V17.8828L47.379 5.53234C48.7466 6.50368 50.026 7.584 51.2089 8.76395C52.3923 9.9439 53.4787 11.2235 54.4524 12.5871L42.0695 24.9376H59.5807C59.8525 26.5534 59.9961 28.2097 59.9961 29.9033V29.9438C59.9961 31.6374 59.8525 33.2968 59.5807 34.9126H42.0665L54.4524 47.26C53.4787 48.6236 52.3923 49.9032 51.2124 51.0831H51.2089C50.026 52.2631 48.7466 53.3465 47.3825 54.3147L34.9966 41.9642V59.4299C33.3793 59.7008 31.7126 59.8438 30.0178 59.8473H29.9743C28.279 59.8438 26.6188 59.7008 24.9985 59.4299V41.9642L12.6162 54.3147C9.88158 52.3751 7.49081 49.9872 5.54279 47.26L17.9257 34.9126H0.41442C0.139707 33.2936 -0.00390625 31.628 -0.00390625 29.9344V29.8475C-0.00105965 29.408 0.0277203 28.871 0.0690575 28.3155L0.0818218 28.1484C0.204218 26.5849 0.41442 24.9376 0.41442 24.9376H17.9257L5.54279 12.5871C6.51352 11.2235 7.59688 9.947 8.77975 8.77021L8.78571 8.76395C9.9662 7.584 11.2486 6.50368 12.6162 5.53234L24.9985 17.8828V0.417183C26.6188 0.146325 28.2826 0.0031133 29.9803 0H30.0149ZM30.0119 22.4438H29.9833C27.7546 22.4438 25.6201 22.8516 23.647 23.5926C22.9075 25.5571 22.4981 27.6866 22.4951 29.9095V29.9375C22.4981 32.1604 22.9075 34.2899 23.65 36.2544C25.6201 36.9954 27.7546 37.4033 29.9833 37.4033H30.0119C32.2406 37.4033 34.3751 36.9954 36.3452 36.2544C37.0877 34.2868 37.4971 32.1604 37.4971 29.9375V29.9095C37.4971 27.6866 37.0877 25.5571 36.3452 23.5926C34.3751 22.8516 32.2406 22.4438 30.0119 22.4438Z",
    fill: "#FF4A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_2084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapier);
export default __webpack_public_path__ + "static/media/zapier.7150eb807869f7b7e92054e3ea1bf162.svg";
export { ForwardRef as ReactComponent };